export const onExternalLinkClickCallback = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
};
